import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { OutingDto } from '../administration/outings/dtos/outing.dto';

@Injectable({
  providedIn: 'root'
})
export class OutingService {

  url: string = environment.api.endpoint;

  constructor(private http: HttpClient) { }

  create(outingDto: OutingDto){
    return this.http.post(`${this.url}/outing/create`, outingDto);
  }

  update(data: any): any{
    return this.http.put(`${this.url}/outing/update`, data)
  }

  createOutingPermission(data: any): any{
    return this.http.post(`${this.url}/outing/permission/create`, data);
  }

  createOutingIteration(data: any){
    return this.http.post(`${this.url}/outing/iteration/create`, data);
  }

  deleteOutingIteration(data: any){
    return this.http.post(`${this.url}/outing/iteration/delete`, data);
  }

  deleteOutingPermission(data: any){
    return this.http.post(`${this.url}/outing/permission/delete`, data);
  }

  getAllByCourse(id: string): any {
    return this.http.get(`${this.url}/outings/course/${id}`);
  }

  getOutingsByOrganization(organizationId: string, filter: any): any{
    return this.http.get(`${this.url}/outings/organization/${organizationId}`, { params: filter });
  }

  getOutingIterationsByOutingId(id: string, filter: any): any{
    return this.http.get(`${this.url}/outings/iterations/outing/${id}`, {params: filter});
  }

  getInvoiceByOutingId(data: any): any{
    return this.http.post(`${this.url}/outing/invoice`, data);
  }

  checkInGolfer(data: any) {
    return this.http.post(`${this.url}/outing/checkin`, data);
  }

  getUsersForPermissions(filter: any): any{
    return this.http.get(`${this.url}/outing/permissionusers`, { params: filter });
  }

  getPermissionTypes(): any{
    return this.http.get(`${this.url}/outing/permission/types`);
  }

  getOutingDetails(id: string): any{
    return this.http.get(`${this.url}/outing/details/${id}`);
  }
}
